
const features = [
    {
        heading: "Instant AI Evaluation",
        description: "Get fast, accurate scoring for speaking and writing using advanced AI models.",
        points: [
            "Detailed feedback in seconds",
            "Clear guidance on strengths and weaknesses",
            "Scores aligned with DET Test algorithms"
        ]
    },
    {
        heading: "Extensive Practice Library",
        description: "Every DET question type with a large, growing bank of exercises.",
        points: [
            "Updated regularly",
            "Searchable and easy to navigate",
            "Easy to Advanced difficulty levels"
        ]
    },
    {
        heading: "Learning Tools & Templates",
        description: "Easy-to-use tools that make studying more organized and effective.",
        points: [
            "Free learning materials",
            "Ready-made practice templates",
            "Step-by-step study guides"
        ]
    }
];


export default function AdvertisementSection() {
    return (
        <section className="advertisement-section">
            <div className="px-[12px] lg:py-[140px] flex justify-center items-center box-border py-[18px] lg:px-[148px]">

                <div className={"flex flex-col gap-[20px] lg:gap-[82px]"}>
                    <div className={"flex flex-col gap-[12px] lg:gap-[24px]"}>
                        <p className={"font-semibold text-[24px] lg:text-[48px] leading-[120%] lg:leading-[120%] text-center"}>
                            How <span className={"text-[#0C98FE]"}>DET</span> Study Helps You
                            <span className={"text-[#58CC03]"}>{" "}Score Higher</span>
                        </p>
                        <p className={" text-[12px] lg:text-[18px] leading-[120%] lg:leading-[120%] text-center"}>

                            Using AI technology and professional materials to make DET preparation more effective
                        </p>
                    </div>

                    <div className={"grid grid-cols-1 lg:grid-cols-3 gap-[24px] lg:gap-[24px]"}>
                        {
                            features.map((feature, index) => (
                                <div key={index}
                                     className={
                                         "flex flex-col cursor-pointer relative group bg-white shadow-sm gap-[8px] lg:gap-[16px] px-[24px] py-[44px] lg:px-[40px] lg:py-[62px] border border-[#E0E0E0] rounded-[16px] " +
                                         "transition-transform duration-300 rounded-[32px] ease-out hover:scale-[1.03]"
                                     }

                                >
                                    <p className={"font-medium group:hover:font-semibold     text-[18px] lg:text-[24px] leading-[120%] lg:leading-[120%]"}>
                                        {feature.heading}
                                    </p>
                                    <p className={" text-[12px] lg:text-[16px] leading-[120%] lg:leading-[120%]"}>
                                        {feature.description}
                                    </p>
                                    <ul className={"list-disc pl-[16px] lg:pl-[24px] flex flex-col gap-[4px] lg:gap-[8px]"}>
                                        {
                                            feature.points.map((point, idx) => (
                                                <li key={idx}
                                                    className={" text-[12px] lg:text-[16px] leading-[120%] lg:leading-[120%]"}>
                                                    {point}
                                                </li>
                                            ))
                                        }
                                    </ul>

                                    <img
                                        src={`./duolingo/${index+1}.svg`}
                                        alt={`feature-${index}`}
                                        className="absolute bottom-[-20px] lg:bottom-[-55px] left-1/2 w-[60px] lg:w-[120px] h-auto -translate-x-1/2"
                                    />


                                </div>
                            ))
                        }

                    </div>
                </div>
            </div>
        </section>
    );
}